/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css } from "@panda/css";

export const richTextContentStyles = css({
	color: "eds.text.secondary",

	"& h1": {
		textStyle: "heading2XL",
		marginBlockStart: "eds.dimension.48",
		marginBlockEnd: "eds.dimension.16",
	},
	"& h2": {
		textStyle: "headingXL",
		marginBlockStart: "eds.dimension.48",
		marginBlockEnd: "eds.dimension.16",
	},
	"& h3": {
		textStyle: "headingLG",
		marginBlockStart: "eds.dimension.40",
		marginBlockEnd: "eds.dimension.12",
	},
	"& h4": {
		textStyle: "headingMD",
		marginBlockStart: "eds.dimension.32",
		marginBlockEnd: "eds.dimension.8",
	},
	"& h5": {
		textStyle: "headingSM",
		marginBlockStart: "eds.dimension.24",
		marginBlockEnd: "eds.dimension.8",
	},
	"& h6": {
		textStyle: "eyebrowLG",
		marginBlockStart: "eds.dimension.24",
		marginBlockEnd: "eds.dimension.8",
	},
	"& p": {
		textStyle: "paragraphLG",
		marginBlockStart: "eds.dimension.4",
		marginBlockEnd: "eds.dimension.24",
	},
	"& p:empty": {
		display: "none",
	},
	"& p:has(+ ul), & p:has(+ ol)": {
		marginBlockEnd: "0",
	},
	"& p + ul, & p + ol": {
		marginBlockStart: "0",
	},
	"& ul, & ol": {
		marginBlockEnd: "eds.dimension.32",
		paddingInlineStart: "eds.dimension.24",
	},
	"& li": {
		textStyle: "paragraphLG",
		marginBlockEnd: "eds.dimension.8",
	},
	"& p + ul li, & p + ol li": {
		marginBlockEnd: "eds.dimension.4",
	},
	"& strong": {
		color: "eds.text.primary",
	},
	"& h1, & h2, & h3, & h4, & h5, & h6": {
		color: "eds.text.primary",
	},
	"& :first-child:is(h1, h2, h3, h4, h5, h6)": {
		marginBlockStart: "0",
	},
	"& hr": {
		marginBlock: "eds.dimension.32",
		width: "100%",
		borderTopWidth: "1px",
		borderTopStyle: "solid",
		borderTopColor: "eds.border.subtle",
	},
});
